import { createSelector, select } from '@ngrx/store';
import { OperatorFunction } from 'rxjs';

import { BookingFeatureState, PaxDetailsState } from '@fcom/common/interfaces/booking';
import { bookingFeatureState } from '@fcom/common/store/selectors/booking-feature-state.selector';

export const paxDetailsSelector = createSelector(bookingFeatureState, (bfs: BookingFeatureState) => bfs?.paxDetails);
const _filteredPaxDetailsPassengers = (passengerIds: string[]) =>
  createSelector(paxDetailsSelector, (pxd: PaxDetailsState) => ({
    ...pxd,
    passengers: pxd?.passengers?.filter((p) => passengerIds.includes(p.travelerId)),
  }));

const _additionalEmails = createSelector(paxDetailsSelector, (pxd: PaxDetailsState) => pxd?.additionalEmails);

export const paxDetailTravelerSelector = createSelector(paxDetailsSelector, (pxd: PaxDetailsState) => pxd?.passengers);

export const paxDetails = (): OperatorFunction<unknown, PaxDetailsState> => select(paxDetailsSelector);
export const additionalEmails = (): OperatorFunction<unknown, string[] | undefined> => select(_additionalEmails);
export const filteredPaxDetails = (passengerIds: string[]): OperatorFunction<unknown, PaxDetailsState> =>
  select(_filteredPaxDetailsPassengers(passengerIds));
